module.exports = __webpack_public_path__ + "img/man--1199.eb2ea36.jpg";